export enum WhiteSpaceGroup {
  AGREEMENT_TYPE,
  PRODUCT_SUBCATEGORY,
  INVOICED_PRODUCT,
  PROJECTS,
  ONE_OFF,
}

export enum WhiteSpaceStatus {
  ACTIVE,
  ANNOTATED,
  PROSPECT,
  OPEN_OPPORTUNITY,
  LOST_OPPORTUNITY,
  DO_NOT_SELL,
}

export enum WhiteSpaceLegend {
  ACTIVE,
  ANNOTATED,
  OPEN_OPPORTUNITY,
  AGREEMENT_TYPE_ACTIVE,
  AGREEMENT_TYPE_HEADER,
  // AGREEMENT_TYPE_LOST_OPPORTUNITY,
  // AGREEMENT_TYPE_OPEN_OPPORTUNITY,
  AGREEMENT_TYPE_PROSPECT,
  PRODUCT_SUBCATEGORY_ACTIVE,
  PRODUCT_SUBCATEGORY_HEADER,
  // PRODUCT_SUBCATEGORY_OPPORTUNITY,
  // PRODUCT_SUBCATEGORY_OPEN_OPPORTUNITY,
  // PRODUCT_SUBCATEGORY_PROSPECT,
  INVOICED_PRODUCT_ACTIVE,
  INVOICED_PRODUCT_HEADER,
  // INVOICED_PRODUCT_OPPORTUNITY,
  // INVOICED_PRODUCT_OPEN_OPPORTUNITY,
  // INVOICED_PRODUCT_PROSPECT,
}
